import React from 'react';
import { MessageList, Message, Avatar } from "@chatscope/chat-ui-kit-react";
import { useLanguage } from '../LanguageContext';

interface WelcomeMessagesProps {
  onAcceptPrivacy: () => void;
  isPartnerMode?: boolean;
}

export const WelcomeMessages: React.FC<WelcomeMessagesProps> = ({ onAcceptPrivacy, isPartnerMode = false }) => {
  const { t } = useLanguage();

  React.useEffect(() => {
    const acceptBtn = document.getElementById("accept-policy");
    if (acceptBtn) {
      acceptBtn.addEventListener("click", onAcceptPrivacy);
      return () => acceptBtn.removeEventListener("click", onAcceptPrivacy);
    }
  }, [onAcceptPrivacy]);

  return (
    <MessageList>
      <Message 
        model={{
          message: isPartnerMode ? t('partnerWelcomeMessage') : t('welcomeMessage'),
          sender: "bot",
          direction: "incoming",
          position: "normal"
        }}
        avatarPosition="bl"
      >
        <Avatar src="/laf-logo.svg" name="LAFly" size="sm" />
      </Message>
      
      <div className="privacy-message">
        <div className="privacy-content">
          {t('privacyMessage')} <a href="https://www.latteartfactory.com/privacy-policy" target="_blank" rel="noopener noreferrer">{t('privacyPolicy')}</a>.
        </div>
        <div className="btn-wrapper">
          <button className="accept-btn" id="accept-policy">{t('accept')}</button>
        </div>
      </div>
    </MessageList>
  );
}; 